export interface IMetaData {
  width: number;
  height: number;
}

const computedWidth = (width: number, height: number) => (width * 250) / height;
export const getImageWidth = (item: IMetaData, boxHeight: number) => {
  return computedWidth(item.width, item.height) + (boxHeight - 150);
};
